import "core-js/modules/es.number.constructor.js";
export function usePagination() {
  var route = useRoute();

  /**
   * Returns current page handling different possible error (page not set, wrong page number)
   */
  var currentPage = computed(function () {
    return Number(route.query.page) > 0 ? Number(route.query.page) : 1;
  });
  return {
    currentPage: currentPage
  };
}